import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Flex } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import Tooltip from '@atlaskit/tooltip';

export function LoadingIndicator() {
	const { formatMessage } = useIntl();

	return (
		<Flex justifyContent="center">
			<Tooltip content={formatMessage(messages.label)}>
				<Spinner testId="loading-indicator" interactionName="content-renderer-loading-indicator" />
			</Tooltip>
		</Flex>
	);
}

const messages = defineMessages({
	label: {
		id: 'content-renderer.progressive-react-serializer.loading-indicator.label',
		defaultMessage: 'Loading...',
		description: 'Label/tooltip of the indicator shown while progressive rendering is in progress.',
	},
});
